import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Phone, Menu, X, Sparkles } from 'lucide-react';
import Logo from './Logo';
import { NAV_LINKS, PHONES } from '../data/mock';

function TopBar() {
  return (
    <div className="coral-gradient text-white text-sm">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-10">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-white/90" />
          <span className="font-medium tracking-wide">Admissions Open for 2026–27 Session</span>
        </div>
        <div className="hidden md:flex items-center gap-5">
          {PHONES.map((p) => (
            <a key={p.value} href={`tel:${p.value}`} className="flex items-center gap-1.5 hover:text-white/80 smooth">
              <Phone className="w-3.5 h-3.5" /> <span>{p.label}</span>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

function DesktopNav() {
  return (
    <nav className="hidden lg:flex items-center gap-1">
      {NAV_LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          end={link.to === '/'}
          className={({ isActive }) =>
            `px-4 py-2 rounded-lg text-[0.92rem] font-medium smooth ${
              isActive ? 'text-coral bg-coral-light' : 'text-stone-700 hover:text-coral hover:bg-coral-light'
            }`
          }
        >
          {link.label}
        </NavLink>
      ))}
    </nav>
  );
}

function MobileMenu({ onNavigate }) {
  return (
    <div className="lg:hidden border-t border-orange-100 bg-white">
      <div className="max-w-7xl mx-auto px-5 py-3 flex flex-col gap-1">
        {NAV_LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.to === '/'}
            onClick={onNavigate}
            className={({ isActive }) =>
              `px-4 py-2.5 rounded-lg font-medium smooth ${
                isActive ? 'text-coral bg-coral-light' : 'text-stone-700'
              }`
            }
          >
            {link.label}
          </NavLink>
        ))}
        <Link
          to="/admissions"
          onClick={onNavigate}
          className="mt-2 btn-primary smooth font-medium px-5 py-2.5 rounded-lg text-center"
        >
          Apply for Admission
        </Link>
      </div>
    </div>
  );
}

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <div className="sticky top-0 z-50">
      <TopBar />
      <header className="bg-white/95 backdrop-blur border-b border-orange-100">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
          <Link to="/" className="smooth">
            <Logo size={42} showTagline={false} />
          </Link>
          <DesktopNav />
          <div className="flex items-center gap-3">
            <Link
              to="/admissions"
              className="hidden sm:inline-flex btn-primary smooth font-medium px-5 py-2.5 rounded-lg text-[0.92rem]"
            >
              Apply for Admission
            </Link>
            <button
              className="lg:hidden p-2 rounded-lg hover:bg-coral-light"
              onClick={() => setOpen((o) => !o)}
              aria-label="toggle menu"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </button>
          </div>
        </div>
        {open && <MobileMenu onNavigate={() => setOpen(false)} />}
      </header>
    </div>
  );
}
